import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么瓜友们都选择51吃瓜黑料网？</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1000px] mx-auto">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center"
            >
              <div className={`w-12 h-12 flex items-center justify-center ${item.color} rounded-xl mx-auto mb-4`}>
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}